import type { ScreenSchema } from './types';

const sliderSchema: ScreenSchema = {
  template: 'slider',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' },
        { field: 'question' }
      ]
    },
    // Single feedback text revealed after submission
    feedback: { parts: [{ field: 'feedback' }] }
  }
};

export default sliderSchema;
